module.exports = __webpack_public_path__ + "img/video-placeholder.663f340f.jpeg";